import React from 'react';
import { Reveal } from './Reveal';
import { SectionHeading } from './SectionHeading';
const items = [['📘', 'Los 12 tomos digitales completos (Primaria y Secundaria)'], ['📝', 'Actividades, proyectos y evaluaciones por nivel'], ['🖌️', 'Técnicas artísticas con explicación paso a paso'], ['📊', 'Rúbricas de evaluación y autoevaluación'], ['🗂️', 'Plantillas de portafolio y galería de trabajos']];
export function InstantAccessSection() {
  return <section className="bg-brand-alt px-4 py-20 sm:py-24" data-id="element-93" data-mp="1wet8hi0p8nvv">
      <Reveal className="mx-auto max-w-3xl" data-id="element-94" data-mp="1rd3x219ke879">
        <SectionHeading title={<>
              <span aria-hidden="true" data-id="element-96" data-mp="25d4xjflx3dm7">📲</span> ¿Qué recibís inmediatamente?
            </>} data-id="element-95" data-mp="25doeou3qtxz6" />
        <ul className="mt-12 divide-y divide-brand-line overflow-hidden rounded-3xl border border-brand-line bg-brand-cream" data-id="element-97" data-mp="20fd3aexsvfeu">
          {items.map(([emoji, text]) => <li key={text} className="flex items-start gap-4 px-6 py-5 sm:px-8" data-id="element-98" data-mp="61lyptubvlq9">
              <span className="text-lg leading-none" aria-hidden="true" data-id="element-99" data-mp="2n2gco5a873tv">
                {emoji}
              </span>
              <span className="text-sm font-medium leading-snug text-brand-text sm:text-base" data-id="element-100" data-mp="2s1t7bc7c9f70">
                {text}
              </span>
            </li>)}
        </ul>
        <p className="mt-10 text-center font-display text-lg italic text-brand-terra sm:text-xl" data-id="element-101" data-mp="31r2zes26mxv4">
          Cubrís el material de todo el año
        </p>
      </Reveal>
    </section>;
}